import { createSlice } from "@reduxjs/toolkit";
import { getTags } from "../../reduxApi/admin/TagReduxApi";

const TagSlice = createSlice({
  name: "tags",
  initialState: {
    status: "idle",
    isFiltered: false,
    tags: [],
    
  },
  reducers: {
    setFilteredStatus: (state, action) => {
      state.isFiltered = action.payload;
    },
    
    deleteTagsAction: (state, action) => {
      // Handle single ID or array of IDs
      const idsToDelete = Array.isArray(action.payload) ? action.payload : [action.payload];
      
      idsToDelete.forEach((id) => {
        const index = state.tags.findIndex((item) => item?.tagMasters?.ROWID === id);
        if (index !== -1) {
          state.tags.splice(index, 1);
        }
      });
    },
    
    updateTagAction: (state, action) => {
      const index = state.tags.findIndex(
        (item) => item?.tagMasters?.ROWID === action.payload.ROWID
      );
      if (index !== -1) {
        // Preserve the structure with tagMasters wrapper
        state.tags.splice(index, 1, { tagMasters: action.payload });
      }
    },
    
    addTagAction: (state, action) => {
      console.log("action--->", action.payload);
      
      const temp = { ...action.payload };
      console.log("temp", temp);
      
      // Ensure ROWID is set correctly
      temp.ROWID = action.payload.ROWID || action.payload.id;
      console.log("temp.ROWID", temp.ROWID);
      
      // Add new data at beginning of array with tagMasters wrapper
      state.tags.unshift({ tagMasters: temp });
    },
    
    // Alternative simpler delete method using filter
    deleteTagsFilterAction: (state, action) => {
      const idsToDelete = Array.isArray(action.payload) ? action.payload : [action.payload];
      state.tags = state.tags.filter(
        (item) => !idsToDelete.includes(item?.tagMasters?.ROWID)
      );
    },
  },
  
  extraReducers: (builder) => {
    builder
      .addCase(getTags.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getTags.fulfilled, (state, action) => {
        state.status = "fulfilled";
        // Assuming the API returns data in the format: { data: { tagMasters: [...] } }
        // or directly as an array
        state.tags = action.payload?.data?.tagMasters || action.payload?.data || [];
      })
      .addCase(getTags.rejected, (state) => {
        state.status = "rejected";
      });
  },
});

export const { 
  deleteTagsAction, 
  deleteTagsFilterAction,
  updateTagAction, 
  addTagAction,
  setFilteredStatus 
} = TagSlice.actions;

export default TagSlice.reducer;